/* adv-advertorial.js — T-ADV. (attribution is shared in plentum-attribution.js) shows the mobile sticky CTA
   whenever the hero buttons are out of view, until the offer block, (3) copy-code button. No libraries, no animation (motion lives in plentum-motion). */
(function () {
  var bar = document.querySelector('[data-adv-sticky]');
  if (bar) {
    var hero = document.querySelector('[data-adv-hero] .adv-btns'), offer = document.querySelector('[data-adv-offer]'), tick = false;
    var upd = function () {
      tick = false;
      var vh = window.innerHeight, r = hero ? hero.getBoundingClientRect() : null;
      var past = r ? (r.bottom < 0 || r.top > vh) : window.scrollY > vh;
      var atOffer = offer ? offer.getBoundingClientRect().top < vh * 0.85 : false;
      var on = past && !atOffer;
      if (on !== bar.classList.contains('is-on')) { bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; }); }
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  document.querySelectorAll('[data-adv-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-adv-copy'), done = function () { var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
  });

  // T-ADVSECTIONS: tap-to-expand comparison rows, the weight picker chips, the proof flip cards and the animated FAQ.
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.adv-cmp__tg').forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-expanded') !== 'true', det = document.getElementById(b.getAttribute('aria-controls'));
      b.setAttribute('aria-expanded', String(on)); b.closest('tr').classList.toggle('is-open', on);
      if (det) det.hidden = !on;
    });
  });

  document.querySelectorAll('[data-adv-dose]').forEach(function (box) {
    var chips = box.querySelectorAll('.adv-dp__chip'), out = box.querySelector('.adv-dp__out');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (o) { o.setAttribute('aria-pressed', String(o === c)); });
        var n = +c.dataset.n || 1, size = c.dataset.size || '';
        box.querySelectorAll('[data-sq]').forEach(function (q) { q.classList.toggle('is-on', +q.dataset.sq <= n); });
        box.querySelector('[data-dp-n]').textContent = n + ' sachet' + (n > 1 ? 's' : '');
        box.querySelector('[data-dp-pd]').textContent = c.dataset.pd || '';
        box.querySelectorAll('[data-dp-size]').forEach(function (s) { s.textContent = size; });
        var go = box.querySelector('[data-dp-go]');
        if (go && c.dataset.url) go.setAttribute('href', window.PlentumAttribution ? window.PlentumAttribution.decorate(c.dataset.url) : c.dataset.url);
        if (!still && out) { out.classList.remove('is-in'); void out.offsetWidth; out.classList.add('is-in'); }
      });
    });
  });

  document.querySelectorAll('[data-adv-flip]').forEach(function (b) {
    var back = document.getElementById(b.getAttribute('aria-controls'));
    if (back) back.setAttribute('aria-hidden', 'true');
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', String(on)); b.classList.toggle('is-flipped', on);
      if (back) back.setAttribute('aria-hidden', String(!on));
    });
  });

  document.querySelectorAll('[data-adv-faq] details').forEach(function (d) {
    var sum = d.querySelector('summary'), a = d.querySelector('.a');
    if (!sum || !a || !a.animate) return;
    sum.addEventListener('click', function (e) {
      if (still) return;
      e.preventDefault();
      if (d.dataset.busy) return;
      d.dataset.busy = '1';
      var done = function () { delete d.dataset.busy; a.style.overflow = ''; };
      a.style.overflow = 'hidden';
      if (!d.open) {
        d.open = true;
        var h = a.offsetHeight;
        a.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = done;
      } else {
        d.classList.add('is-closing');
        a.animate([{ height: a.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: 'ease-in' }).onfinish = function () { d.open = false; d.classList.remove('is-closing'); done(); };
      }
    });
  });
})();
